import React ,{useState, useEffect} from 'react';
// import Link from 'react-router-dom';
import '../css/products.css';
import axios from 'axios';
import { useStateValue } from '../StateProvider';
function Products() {
   //let url ='https://fakestoreapi.com/products';
    
   const [stored, setStore] = useState([]);
   useEffect(() => {
       axios.get('https://fakestoreapi.com/products')
       .then(resdata => {
        const response = resdata;
        console.log(response.data);
        setStore(response.data);
       })
       .catch(err => console.log(err));
   },[]);

   const [state, dispatch] = useStateValue();
   const addToBasket = (id,title,image,price) => {
      // dispatch the item into the data layer
      dispatch({
          type:'ADD_TO_BASKET',
          item:{
              id:id,
              title:title,
              image:image,
              price:price,
             
          }
      })
    console.log("bhjb")
   }

    return(
        <div className="products">
            <div className="products-container">
                {
                    stored.map(stor => (
                       
                        <div className="box" key={stor.id}>
                            <div className="image-section">
                            <img src={stor.image} alt="ihdkh" />
                            </div>
                            <p className="category">{stor.category}</p>
                            <span className="price">{stor.price}$</span>
                            <p className="title">{stor.title}</p>
                            {/* <p data-maxlength="100" className="description">{stor.description}</p> */}
                            <button onClick={addToBasket}>Add to Cart</button>
                        </div>
                        
                    ))
                }
                
            </div>
        </div>
    )
}

export default Products;